import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { PublicationStatus } from '@uno/common-cms';
import { ContentSidebar as SideBar } from 'components/content/ContentSidebar';
import { useFormErrors, usePublicationStatus } from 'libs/content/hooks';
import { getValidateSchema } from 'redux/content';

var ContentSideBar = function ContentSideBar(_ref) {
  var content = _ref.content,
      pageMetaData = _ref.pageMetaData,
      pageMetaDataLoading = _ref.pageMetaDataLoading,
      fetchPageMetaData = _ref.fetchPageMetaData;

  var _useFormContext = useFormContext(),
      formState = _useFormContext.formState,
      formHandleSubmit = _useFormContext.handleSubmit;

  var showErrors = useFormErrors();

  var _useState = useState(false),
      callSubmit = _useState[0],
      setCallSubmit = _useState[1];

  var validateSchema = useSelector(getValidateSchema);

  var _usePublicationStatus = usePublicationStatus(pageMetaData, pageMetaDataLoading),
      isStateReady = _usePublicationStatus.isStateReady,
      isPublishing = _usePublicationStatus.isPublishing,
      handleSubmit = _usePublicationStatus.handleSubmit,
      publicationState = _usePublicationStatus.publicationState,
      setCurrentPublicationStatus = _usePublicationStatus.setCurrentPublicationStatus,
      updatePublicationStatus = _usePublicationStatus.updatePublicationStatus;

  var onSubmitChecker = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!formState.isSubmitting) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return handleSubmit();

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [formState.isSubmitting, handleSubmit]);
  var onInvalid = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(errors) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (content !== undefined) {
                showErrors(errors, content.contentType);
              }

              if (!(pageMetaData !== undefined)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return fetchPageMetaData();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [content, fetchPageMetaData, pageMetaData, showErrors]);
  var submitForm = useCallback(function () {
    void formHandleSubmit(onSubmitChecker, onInvalid)();
  }, [formHandleSubmit, onInvalid, onSubmitChecker]);

  var isReadyToSubmit = function isReadyToSubmit(_ref4) {
    var currentPublicationStatus = _ref4.currentPublicationStatus,
        newPublicationStatus = _ref4.newPublicationStatus,
        scheduledPublicationDate = _ref4.scheduledPublicationDate;
    return newPublicationStatus !== (currentPublicationStatus === null || currentPublicationStatus === void 0 ? void 0 : currentPublicationStatus.publicationStatus) || newPublicationStatus === PublicationStatus.SCHEDULED && scheduledPublicationDate !== undefined && scheduledPublicationDate !== (currentPublicationStatus === null || currentPublicationStatus === void 0 ? void 0 : currentPublicationStatus.publishAt);
  };

  useEffect(function () {
    if (callSubmit === true && validateSchema && isStateReady(publicationState)) {
      if (isReadyToSubmit(publicationState)) {
        var _publicationState$sch, _publicationState$cur;

        submitForm();
        setCurrentPublicationStatus({
          publicationStatus: publicationState.newPublicationStatus,
          publishAt: (_publicationState$sch = publicationState.scheduledPublicationDate) !== null && _publicationState$sch !== void 0 ? _publicationState$sch : (_publicationState$cur = publicationState.currentPublicationStatus) === null || _publicationState$cur === void 0 ? void 0 : _publicationState$cur.publishAt
        });
      }
    }
  }, [callSubmit, isStateReady, publicationState, setCurrentPublicationStatus, submitForm, validateSchema]);

  if (!isStateReady(publicationState)) {
    return null;
  }

  return __jsx(SideBar, {
    lastModified: content === null || content === void 0 ? void 0 : content.modified,
    onDialogClose: function onDialogClose() {
      return setCallSubmit(true);
    },
    isPublishing: isPublishing,
    state: publicationState,
    onPublishConfirm: updatePublicationStatus,
    submitForm: submitForm
  });
};

export default ContentSideBar;